"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const assets_1 = require("~/assets");
const ErrorModal_1 = __importDefault(require("../ErrorModals/ErrorModal"));
class ErrorBoundary extends react_1.Component {
    constructor() {
        super(...arguments);
        // eslint-disable-next-line react/state-in-constructor
        this.state = {
            hasError: false,
        };
    }
    static getDerivedStateFromError(_) {
        return { hasError: true };
    }
    componentDidCatch(error, errorInfo) {
        console.error('Uncaught error:', error, errorInfo);
    }
    render() {
        const { hasError } = this.state;
        const { children, t } = this.props;
        if (hasError) {
            return (react_1.default.createElement(ErrorModal_1.default, { icon: assets_1.svgNotFound, header: t('error-boundary.error-header'), messages: [t('error-boundary.something-happened'), t('error-boundary.please-reload')], imgClassName: "not_found", errorBoundary: true }));
        }
        return children;
    }
}
exports.default = (0, react_i18next_1.withTranslation)('errors')(ErrorBoundary);
